//@ts-check
import { DeleteOutline } from "@mui/icons-material";
import React, { useState } from "react";

export const ModernCollapsible = ({ title, elementId, index, onDelete, children }) => {
    const [activeCollapsibleIndex, setActiveCollapsibleIndex] = useState([0]);
    const isActive = activeCollapsibleIndex.includes(index);
    const toggleCollapsible = (newIndex) => {
        if (activeCollapsibleIndex.includes(newIndex)) {
            closeCollapsible(newIndex);
        } else {
            openCollapsible(newIndex);
        }
    };
    const openCollapsible = (newIndex) => {
        setActiveCollapsibleIndex((prev) => {
            return [...prev, newIndex];
        });
    };
    const closeCollapsible = (newIndex) => {
        setActiveCollapsibleIndex((prev) => {
            return prev.filter((index) => index !== newIndex);
        });
    };
    return (<div
        className="mt-2 transition-all ease-in-out duration-300 "
    >
        <button
            className=" flex items-center justify-between w-full focus:outline-none bg-[#F4F7FA] p-4 rounded-t-lg "
            onClick={() => {
                toggleCollapsible(index);
            }}
        >
            <div className="flex item-center justify-center ">
                {!isNaN(index) && <div className="h-10 w-10 mr-2 text-md bg-[#3cc3aa] text-white font-bold p-2 rounded-md">
                    {String(index + 1).padStart(2, "0")}
                </div>}
                <div
                    className="text-lg font-bold flex items-center"
                    dangerouslySetInnerHTML={{
                        __html:
                            title.length > 50
                                ? title.slice(0, 50) + "..."
                                : title,
                    }}
                ></div>
            </div>
            <div className="flex items-center">
                <DeleteOutline
                    onClick={(e) => {
                        e.stopPropagation();
                        onDelete(elementId);
                    }}
                    className="hover:text-red-500 hover:scale-110"
                />
                <svg
                    className={`w-5 h-5 transition-transform ${activeCollapsibleIndex.includes(index)
                        ? "transform rotate-180"
                        : ""
                        }`}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M19 9l-7 7-7-7" />
                </svg>
            </div>
        </button>
        <div
            className={` bg-[#3cc3aa] bg-opacity-5 ${isActive
                ? "max-h-[900px] p-4 "
                : "max-h-0 bg-white overflow-hidden"
                } transition-all duration-300 ease-in-out transition-max-height rounded-b-lg `}
        >
            {children}

        </div>
    </div>
    );
}